webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(18)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(23),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(14)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(19),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(15)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(20),
  /* scopeId */
  "data-v-74955cf8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(17)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(22),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(16)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(21),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Hello__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Bostadsratt__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Bostadsratt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Bostadsratt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Kostnadsbaserad__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Kostnadsbaserad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Kostnadsbaserad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Rum__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Rum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Rum__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var routes = [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_3__components_Hello___default.a }, { path: '/hyra-ut-bostadsratt', component: __WEBPACK_IMPORTED_MODULE_4__components_Bostadsratt___default.a }, { path: '/kostnadsbaserad-hyra', component: __WEBPACK_IMPORTED_MODULE_5__components_Kostnadsbaserad___default.a }, { path: '/hyra-ut-rum', component: __WEBPACK_IMPORTED_MODULE_6__components_Rum___default.a }];

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: routes,
  mode: 'history'
});






new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',

  template: '<App/>',

  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },

  router: router
}).$mount('#app');

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hyra-ut-bostadsratt'
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'kostnadsbaserad-hyra'
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hyra-ut-rum'
});

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hyra-ut-bostadsratt"
    }
  }, [_c('h1', [_vm._v("Hyra ut bostadsrätt")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', [_vm._v("Vad får man ta i hyra")]), _vm._v(" "), _c('p', [_vm._v("När du hyr ut en bostadsrätt har du rätt att ta ut en "), _c('router-link', {
    attrs: {
      "to": '/kostnadsbaserad-hyra'
    }
  }, [_vm._v("kostnadsbaserad hyra")])], 1), _vm._v(" "), _c('h2', [_vm._v("Länkar")]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Det finns några viktiga faktorer att tänka på om du skall hyra ut en bostadsrätt i andrahand. Hyran du får ta ut regleras av "), _c('strong', [_vm._v("privatuthyrningslagen")]), _vm._v(", men detta gäller bara den första bostadsrätten du hyr ut, om du hyr ut två bostadsrätter.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Om du hyr ut "), _c('strong', [_vm._v("fler än två")]), _vm._v(" bostadsrätter så är det istället "), _c('strong', [_vm._v("hyreslagen")]), _vm._v(" som reglerar vad du får ta i hyra.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "http://www.notisum.se/Pub/Doc.aspx?url=/rnp/sls/lag/20120978.htm"
    }
  }, [_vm._v("Privatuthyrningslagen")])])
}]}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v("Hyreshjälpen")]), _vm._v(" "), _c('p', [_vm._v("Välkommen till "), _c('strong', [_vm._v("hyreshjälpen")]), _vm._v(", en sajt som finns till för att informera om vilka regler och lagar som gäller när man skall hyra eller hyra ut.")]), _vm._v(" "), _c('p', [_vm._v("Den extrema bostadsbrist som finns, framförallt i Stockholm, har gjort att många bor i tredje hand eller hyr svart. Många betalar oerhört höga hyror.")]), _vm._v(" "), _c('p', [_vm._v("I Sverige finns det lagar som reglerar uthyrning i andra hand, håll koll på dina rättigheter så att du slipper betala pengar i onödan.")])])
}]}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hyra-ut-rum"
    }
  }, [_c('h1', [_vm._v("Hyra ut rum")]), _vm._v(" "), _c('p', [_vm._v("När man hyr ut rum får man inte sätta hyran hur högt man vill.")])])
}]}

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "kostnadsbaserad-hyra"
    }
  }, [_c('h1', [_vm._v("Kostnadsbaserad Hyra")]), _vm._v(" "), _c('p', [_vm._v("En "), _c('strong', [_vm._v("kostnadsbaserad hyra")]), _vm._v(" får inte vara påtagligt högre än summan av uthyrarens kapitalkostnad och driftkostnad.")])])
}]}

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "box header"
  }, [_vm._v("Hyreshjälpen")]), _vm._v(" "), _c('div', {
    staticClass: "box sidebar"
  }, [_c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v("Hyreshjälpen")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/hyra-ut-bostadsratt'
    }
  }, [_vm._v("Hyra ut bostadsrätt")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/kostnadsbaserad-hyra'
    }
  }, [_vm._v("Kostnadsbaserad hyra")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/hyra-ut-rum'
    }
  }, [_vm._v("Hyr ut rum")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box content"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "box footer"
  }, [_vm._v("Hyreshjälpen är en gratis sajt för att informera om hyrestagares rättigheter.")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "container"
    }
  })])
},staticRenderFns: []}

/***/ })
],[8]);


// WEBPACK FOOTER //
// static/js/app.acf19663532146098dcd.js